<template>
  <div class="lottie-container">
    <lottie-player
      ref="lottie"
      :style="`width: ${animationWidth}`"
      src="/Lottie/progress-bar.json"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const lottie = ref();
const props = defineProps<{ width?: string }>();
const animationWidth = computed<string>(() => props.width || "300px");

function playAnimation(): void {
  lottie.value.seek("0%");
  lottie.value.play();
}

defineExpose({
  playAnimation,
});
</script>

<style scoped lang="less">
.lottie-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
